import INotesAppState from '../interfaces/notesAppState';
import IAction from '../interfaces/action';
import TabName from '../interfaces/tabName';
import { actions } from './actions';

const initialState: INotesAppState = {
    notes: [],
}

const reducer = (state = initialState, action: IAction): INotesAppState => {
    let notes = []
    switch (action.type) {
        case actions.setAllNotes:
            notes = action.payload;
            return { ...state, notes };
        default:
            return state;
    }
}

export default reducer;